import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchCustomers = createAsyncThunk('customers/fetch', async (arg) => {
  const { page = 1, limit = 50 } = arg || {};
  const res = await axios.get(`/merchant/customers?page=${page}&limit=${limit}`);
  return res.data; // { customers, total, page, limit }
});

export const createCustomer = createAsyncThunk('customers/create', async ({ customer }, { rejectWithValue }) => {
  try {
    const res = await axios.post(`/merchant/customers`, customer);
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message || 'Failed to create customer');
  }
});

const customersSlice = createSlice({
  name: 'customers',
  initialState: { items: [], status: 'idle', error: null, total: 0, page: 1, limit: 50 },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchCustomers.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchCustomers.fulfilled, (s, a) => { 
       s.status = 'succeeded'; 
       s.items = a.payload.customers || a.payload; 
       s.total = a.payload.total || s.items.length;
       s.page = a.payload.page || 1;
       s.limit = a.payload.limit || 50;
     })
     .addCase(fetchCustomers.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(createCustomer.fulfilled, (s, a) => { s.items = [a.payload, ...s.items]; })
     .addCase(createCustomer.rejected, (s, a) => { s.error = a.payload || a.error.message; });
  }
});

export default customersSlice.reducer;
